import { useLayoutEffect } from "react"
import { useLocation } from "react-router-dom"

/**
 * ScrollToTop component that scrolls all scroll containers to the top on route changes.
 * This solves the issue where navigating to a new page preserves the scroll
 * position from the previous page.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()

  // Use useLayoutEffect to scroll before the browser paints
  useLayoutEffect(() => {
    // Scroll window
    window.scrollTo({ top: 0, left: 0, behavior: "instant" })
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0

    // Scroll the main content container (used in MainLayout)
    const mainContainer = document.getElementById("main-scroll-container")
    if (mainContainer) {
      mainContainer.scrollTop = 0
    }
  }, [pathname])

  return null
}
